import React, { useEffect } from "react";
import { Image } from "react-bootstrap";
import Utils from "../../configs/Utils";
import Orders from "../../Components/Orders";
import { faBagShopping } from "@fortawesome/free-solid-svg-icons";
import PageHeader from "../../Components/Common/PageHeader";

const OrdersPage = () => {
  useEffect(() => {
    Utils.setPageTitle("Orders page");
  }, []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader 
          title="All Orders" 
          description="Sync orders, process fulfillment" 
          icon={faBagShopping} 
        />

        <Orders />
      </div>
    </main>
  );
};

export default OrdersPage;
